import React from 'react';
import { Link } from 'react-router-dom';

const CategoryCard = ({ category }) => {
  const { name, slug, image, description } = category;
  
  return (
    <Link to={`/category/${slug}`} className="category-card">
      <div className="category-image">
        <img src={image} alt={name} />
      </div>
      <div className="category-overlay">
        <h3>{name}</h3>
        <p>{description}</p>
      </div>
      
      <style jsx>{`
        .category-card {
          position: relative;
          height: 200px;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease;
        }
        
        .category-card:hover {
          transform: translateY(-5px);
        }
        
        .category-image {
          height: 100%;
        }
        
        .category-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        
        .category-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
          color: white;
          padding: 1.5rem;
          transition: background 0.3s ease;
        }
        
        .category-card:hover .category-overlay {
          background: linear-gradient(transparent, rgba(0, 0, 0, 0.9));
        }
        
        .category-overlay h3 {
          margin-bottom: 0.5rem;
        }
        
        .category-overlay p {
          font-size: 0.9rem;
          opacity: 0.9;
        }
      `}</style>
    </Link>
  );
};

export default CategoryCard;